import React, { useContext } from 'react';
import { neverop } from 'utils/noop';
import { usePlayerProvider } from './usePlayerProvider';
import { PlayerContextType, PlayerProviderProps } from './types';

export const DefaultPlayerContext = {
    currentTime: 0,
    loading: false,
    playing: false,
    totalTime: 0,
    togglePlaying: neverop('PlayerProvider', 'togglePlaying'),
    playFromBeginning: neverop('PlayerProvider', 'playFromBeginning'),
    seek: neverop('PlayerProvider', 'seek'),
};

export const PlayerContext =
    React.createContext<PlayerContextType>(DefaultPlayerContext);

export const PlayerProvider = ({
    children,
    streamEntityType,
    playerId,
    customStreamUrl,
}: PlayerProviderProps): JSX.Element => {
    const context = usePlayerProvider({
        streamEntityType,
        id: playerId,
        customStreamUrl,
    });

    return (
        <PlayerContext.Provider value={context}>
            {children}
        </PlayerContext.Provider>
    );
};

export const usePlayerContext = (): PlayerContextType =>
    useContext(PlayerContext);
